var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwilioIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2500 2500",
    style: {
      enableBackground: "new 0 0 2500 2500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CF272D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1248.6,1996.3c-411.4,0-744.9-333.5-744.9-744.9c0-411.4,333.5-744.9,744.9-744.9 c411.4,0,744.9,333.5,744.9,744.9C1993.5,1662.8,1660,1996.3,1248.6,1996.3L1248.6,1996.3z M1248.6,239.9 C690,239.9,237.2,692.8,237.2,1251.4c0,558.6,452.8,1011.4,1011.5,1011.4c558.6,0,1011.4-452.8,1011.4-1011.4 C2260.1,692.8,1807.2,239.9,1248.6,239.9L1248.6,239.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1290.2,999.5c0-116.1,94.2-210.3,210.3-210.3s210.3,94.2,210.3,210.3c0,116.2-94.2,210.3-210.3,210.3 C1384.4,1209.8,1290.2,1115.6,1290.2,999.5 M1290.2,1503.3c0-116.1,94.2-210.3,210.3-210.3s210.3,94.2,210.3,210.3 c0,116.2-94.2,210.3-210.3,210.3C1384.4,1713.6,1290.2,1619.4,1290.2,1503.3 M786.4,1503.3c0-116.1,94.2-210.3,210.3-210.3 c116.2,0,210.3,94.2,210.3,210.3c0,116.2-94.2,210.3-210.3,210.3C880.6,1713.6,786.4,1619.4,786.4,1503.3 M786.4,999.5 c0-116.2,94.2-210.3,210.3-210.3c116.2,0,210.3,94.2,210.3,210.3c0,116.2-94.2,210.3-210.3,210.3 C880.6,1209.8,786.4,1115.6,786.4,999.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwilioIcon);
export default __webpack_public_path__ + "static/media/Twilio Icon.43d0096f9244e9196901840a25855b06.svg";
export { ForwardRef as ReactComponent };